import {
	FETCH_PATIENT_ACTIVE_LIST_REQUEST,
	FETCH_PATIENT_ACTIVE_LIST_SUCCESS,
	FETCH_PATIENT_ACTIVE_LIST_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
}

const patientListActiveReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_PATIENT_ACTIVE_LIST_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case FETCH_PATIENT_ACTIVE_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case FETCH_PATIENT_ACTIVE_LIST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default patientListActiveReducer